import axios from 'axios'
import {Constants} from "../constants";


/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
    baseURL: Constants.SERVER_ENDPOINT
});


/**
 * Request Wrapper with default success/error actions
 */
const request = function (options) {
    const onError = function (error) {
        console.error('Request Failed:', error.config);

        if (error.response) {
            // Request was made but server responded with something
            // other than 2xx
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data);
            console.error('Headers:', error.response.headers);

            if (error.response.status === 403) {
                localStorage.removeItem(Constants.STORAGE_JWT_TOKEN_KEY);
            }
        } else {
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error);
    };

    if (!options) {
        options = {}
    }

    options = {
        ...options,
        headers: {
            ...options.headers,
            'Authorization': localStorage.getItem(Constants.STORAGE_JWT_TOKEN_KEY)
        }
    };

    return client(options)
        .catch(onError);
};

export default request;